import { useMutation } from "react-query";
import axios from "../axios";

type DownloadKatalogExcelBody = {
    ukmId?: number;
    kategori: string;
};

const downloadKatalogExcel = async (body: DownloadKatalogExcelBody) => {
    const response = await axios.post<Blob>(
        "/api/downloadkatalogexcel",
        body,
        { responseType: "blob" },
    );
    return response.data;
};

export default function useDownloadKatalogExcel() {
    return useMutation((body: DownloadKatalogExcelBody) =>
        downloadKatalogExcel(body),
    );
}
